function vemalieImagesForColour(items, colour) {
  return items.filter(function (item) { return item.colour === colour; });
}
function vemalieGalleryStep(count, current, direction) {
  return count > 0 ? (current + direction + count) % count : -1;
}
function vemalieInitGalleries(root) {
  root.querySelectorAll('[data-v-gallery]').forEach(function (gallery) {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    var scope = gallery.closest('[data-v-product]') || gallery;
    var main = gallery.querySelector('[data-v-main]');
    var caption = gallery.querySelector('[data-v-caption]');
    var thumbs = Array.from(gallery.querySelectorAll('[data-v-image]'));
    var colours = Array.from(scope.querySelectorAll('[data-v-colour]'));
    var dialog = gallery.querySelector('[data-v-zoom-dialog]');
    var opener = gallery.querySelector('[data-v-zoom-open]');
    var zoomImage = gallery.querySelector('[data-v-zoom-image]');
    var active = thumbs.find(function (button) { return !button.hidden; });
    function visibleThumbs() { return thumbs.filter(function (button) { return !button.hidden; }); }
    function syncZoom() {
      if (!dialog.open) return;
      zoomImage.src = main.src;
      zoomImage.alt = main.alt;
      gallery.querySelector('[data-v-zoom-caption]').textContent = main.alt;
      var visible = visibleThumbs();
      gallery.querySelector('[data-v-image-count]').textContent = String(visible.indexOf(active) + 1) + ' / ' + visible.length;
      gallery.querySelector('[data-v-prev]').disabled = visible.length < 2;
      gallery.querySelector('[data-v-next]').disabled = visible.length < 2;
    }
    function show(button) {
      active = button;
      main.src = button.dataset.src;
      main.alt = button.dataset.alt;
      caption.textContent = button.dataset.alt;
      thumbs.forEach(function (thumb) { thumb.setAttribute('aria-pressed', String(thumb === button)); });
      syncZoom();
    }
    function step(direction) {
      var visible = visibleThumbs();
      var index = vemalieGalleryStep(visible.length, visible.indexOf(active), direction);
      if (index >= 0) show(visible[index]);
    }
    opener.addEventListener('click', function () {
      if (typeof dialog.showModal !== 'function') return;
      dialog.showModal();
      syncZoom();
    });
    gallery.querySelector('[data-v-zoom-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () { opener.focus({preventScroll: true}); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    gallery.querySelector('[data-v-prev]').addEventListener('click', function () { step(-1); });
    gallery.querySelector('[data-v-next]').addEventListener('click', function () { step(1); });
    gallery.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (!dialog.open && !event.target.closest('[data-v-image]')) return;
      event.preventDefault();
      step(event.key === 'ArrowRight' ? 1 : -1);
      if (!dialog.open) active.focus({preventScroll: true});
    });
    thumbs.forEach(function (button) { button.addEventListener('click', function () { show(button); }); });
    colours.forEach(function (button) {
      button.addEventListener('click', function () {
        var visible = vemalieImagesForColour(thumbs.map(function (thumb) { return {colour: thumb.dataset.colour, button: thumb}; }), button.dataset.vColour);
        if (!visible.length) return;
        thumbs.forEach(function (thumb) { thumb.hidden = thumb.dataset.colour !== button.dataset.vColour; });
        colours.forEach(function (colour) { colour.setAttribute('aria-pressed', String(colour === button)); });
        scope.querySelector('[data-v-sku]').textContent = button.dataset.sku;
        scope.querySelector('[data-v-colour-name]').textContent = button.dataset.colourLabel;
        show(visible[0].button);
      });
    });
  });
}
document.addEventListener('DOMContentLoaded', function () { vemalieInitGalleries(document); });
document.addEventListener('shopify:section:load', function (event) { vemalieInitGalleries(event.target); });
